import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Cabecalho from 'Component/Admin/Cabecalho';
import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, {
  Botao as BotaoForm,
} from 'Component/Form';
import Campo from 'Component/Form/Campo';
import { useEditarTarefaMutation } from 'View/Service/Default/Tarefas';

const AlterarTitulo = (): React.ReactElement => {
  const toast = useToast();
  const navigate = useNavigate();
  const { id = 0 } = useParams();

  const [editarTarefa] = useEditarTarefaMutation();

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho
        titulo="Alterando Título"
        descricao="Preencha o formulário e clique em Alterar para alterar o título da tarefa"
      />
    <div className="container d-flex justify-content-center align-items-center card" style={{ width: '690px' }}>
      <div className="card-shadow p-4">
      <Form
        inicial={{ titulo: '' }}
        onSubmit={async (values, formikHelpers) => {
          try {
            await editarTarefa({ id: Number(id), titulo: values.titulo })
            toast({
              conteudo: 'Título da tarefa alterado com sucesso !',
              tema: 'success'
            })
            navigate(-1);
          } catch (erro) {
            toast({
              titulo: 'Erro ao alterar o título da tarefa',
              conteudo: 'Recarregue a pagina ou retorne',
              tema: 'danger'
            })
          } finally {
            formikHelpers.setSubmitting(false);
          }
        }}
      >
        <div style={{ width: '650px' }}>
    <Campo
      ajuda="Digite o novo título para a tarefa. O título deve ser claro e objetivo."
      name="titulo"
      rotulo="Novo título"
    />
  </div>
        <BotaoForm type='submit' tema='primary'>Alterar</BotaoForm>
        <Botao onClick={ () => navigate(-1) } tema="outline-primary" className="ms-2" icone="arrow-left">Voltar</Botao>
      </Form>

      </div>
    </div>
    </div>
  );
};

export default AlterarTitulo;
